// test2567
(2567 && 0);
